<div class="page-wrapper">
    <div>
        <app-navbar></app-navbar>
    </div>
    <main class="main-content">
        <router-outlet></router-outlet>
        <!-- Login overlay -->
        <div class="overlay" *ngIf="doLogin" (click)="closeLogin()">

            <div class="login-box"
                 style="height:auto; overflow:auto;"
                 (click)="$event.stopPropagation()">

                <!-- Close Button -->
                <button class="close-btn"
                        type="button"
                        (click)="closeLogin()">
                    ×
                </button>

                <app-login (registerClicked)="switchToRegister()"></app-login>

            </div>

        </div>

        <!-- Register overlay -->
        <div class="overlay" *ngIf="doRegister" (click)="doRegister = false">
            <div class="login-box" style="height: auto;overflow: auto;" (click)="$event.stopPropagation()">
                <!-- Close Button -->
                <button class="close-btn" type="button" (click)="doRegister = false">×</button>
                <app-register (loginClicked)="switchToLogin()"></app-register>
            </div>
        </div>

        <a
                href="https://wa.me/7020864796?text=Hi%20I%20am%20interested"
                target="_blank"
                class="whatsapp-float"
        >
            <svg viewBox="0 0 32 32" width="55" height="55">
                <path fill="#25D366" d="M16 .5C7.5.5.6 7.4.6 16c0 2.8.7 5.4 2 7.7L.5 31.5l7.9-2.1c2.2 1.2 4.7 1.8 7.2 1.8 8.5 0 15.4-6.9 15.4-15.4S24.5.5 16 .5zm0 28c-2.4 0-4.7-.6-6.7-1.7l-.5-.3-4.7 1.3 1.3-4.6-.3-.5C3.9 20.7 3.3 18.4 3.3 16c0-7 5.7-12.7 12.7-12.7S28.7 9 28.7 16 23 28.5 16 28.5zm6.9-9.6c-.4-.2-2.2-1.1-2.5-1.2-.3-.1-.5-.2-.7.2s-.8 1.2-1 1.4c-.2.2-.4.3-.7.1s-1.3-.5-2.5-1.6c-.9-.8-1.6-1.8-1.8-2.1-.2-.3 0-.5.1-.7.1-.1.3-.4.5-.6.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6s-.7-1.8-1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4s-1.2 1.2-1.2 2.9 1.2 3.3 1.4 3.6c.2.3 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2.1.1.6-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5z"/>
            </svg>
        </a>
    </main>
    <app-footer></app-footer>
</div>